import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import Chart from "react-apexcharts";

import { GET_BROKER_PROJECT_HOURS } from "../../constants/ApiRoute";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import { authHeader } from "../comman/MainFunction";
import API from "../comman/API";
import NoRecordFound from "../comman/NoRecordFound";
import downloadIcon from "../../images/download-icon.svg";

export default function ProjectHourGraph(props) {
  const { customerTab, brokerTab, selectedCustomer, selectedBroker } = props;

  const [optionss, setOptionss] = useState({});
  const [seriess, setSeriess] = useState([]);
  const [chartHeight, setChartHeight] = useState("300px");

  const [projectIdVal, setprojectIdVal] = useState("");

  let downloadFileName = 'Dashboard_Project_Hour';

  if(customerTab?.brokerId){
     downloadFileName = `${selectedCustomer?.CustomerName.replace(/[^a-zA-Z0-9_ ]/g, '').replace(/ /g, '_')}_Dashboard_Project_Hour`;
  }
  if(brokerTab?.brokerId){
    downloadFileName = `${selectedBroker?.BrokerName.replace(/[^a-zA-Z0-9_ ]/g, '').replace(/ /g, '_')}_Dashboard_Project_Hour`;
  }

  useEffect(() => {
    if (customerTab.brokerId) {
      setprojectIdVal(customerTab.brokerId);
    }
  }, [customerTab.brokerId]);

  useEffect(() => {
    if (brokerTab.brokerId) {
      setprojectIdVal(brokerTab.brokerId);
    }
  }, [brokerTab.brokerId]);

  useEffect(() => {
    if (projectIdVal) {
      getProjectHourFunction();
    }
  }, [projectIdVal]);

  const getProjectHourFunction = async () => {
    console.log("API CALL FOR PROJECT HOUR", props);

    const config = {
      method: "GET",
      url: GET_BROKER_PROJECT_HOURS,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify({ userId: projectIdVal })),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        if (data && data[0]) {
          var filteredProjectDataArray = data.filter(function (item) {
            return item.ProjName !== null && item.TotalHours;

            // if(customerTab.brokerId){
            //   return item.ProjName !== null && item.TotalHours && item.ProjID == customerTab.projectId;
            // }else{
            //   return item.ProjName !== null && item.TotalHours;
            // }
          });

          var ProjNames = filteredProjectDataArray.map((item) => item.ProjName);
          var totalHours = filteredProjectDataArray.map(
            (item) =>  item.TotalHours != null ? parseFloat(item.TotalHours).toFixed(2) : "0.00"
          );

          var option = {
            series: [
              {
                data: totalHours?.map(Number),
              },
            ],
            chart: {
              type: "bar",
              toolbar: {
                show: true,
                tools: {
                  download: `<div id="custom-download-icon" title="Download"><img src=${downloadIcon} /></div>`,
                },
                export: {
                  png: {
                    filename: downloadFileName,
                  }
                }
              },
              events: {
                click: function () {
                  customDownloadFunction();
                },
                beforeMount: function () {
                  customDownloadFunction();
                },
                mounted: function () {
                  customDownloadFunction();
                },
                mounted: function () {
                  customDownloadFunction();
                },
              },
            },
            plotOptions: {
              bar: {
                borderRadius: 4,
                borderRadiusApplication: "end",
                horizontal: true,
              },
            },
            dataLabels: {
              enabled: false,
              formatter: function (val) {
                return val.toFixed(2); // Display values with two decimals
              },
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return val.toFixed(2); // Ensure tooltip shows two decimals
                },
              },
            },
            xaxis: {
              categories: ProjNames,
            },
          };
          console.log("option==>", option);
          setOptionss(option);

          setSeriess([
            {
              name: "Project Hours",
              data: totalHours?.map(Number),
            },
          ]);

          // graph height calc

          if (totalHours.length > 10) {
            let a = totalHours.length - 10;
            let b = a / 10;

            if (b) {
              setChartHeight(parseInt(b * 300 + 300));
              console.log("bbbbbbbbbbb", b);
            }
          } else {
            setChartHeight("300px");
          }
        }
      }
    } catch (error) {
      setOptionss({});
      setSeriess([]);
      setChartHeight("300px");
      console.log(" Error Meassage For Statistic", error);
    }
  };

  const customDownloadFunction = () => {
    const svgItem = document.querySelector(".exportSVG");
    const csvItem = document.querySelector(".exportCSV");
    if (svgItem) svgItem.remove();
    if (csvItem) csvItem.remove();
  };

  return (
    <>
      <Box className="bg-box user-log" sx={{ mt: "15px", mr: "9.5px" }}>
        <Typography className="dashboard-title">Project Hours</Typography>
        <div
          className="barchart"
          style={{
            width: "100%",
            margin: "0 auto",
          }}
        >
          {optionss &&
          optionss.series &&
          optionss.series[0] &&
          optionss.series[0].data &&
          optionss.series[0].data.length > 0 ? (
            <div
              className="responsive-chart"
              style={
                optionss.series[0].data.length > 10
                  ? {
                      height: "500px",
                      overflowY: "scroll",
                    }
                  : {}
              }
            >
              <Chart
                options={optionss}
                series={seriess}
                type="bar"
                height={chartHeight}
                width="100%"
              />
            </div>
          ) : (
            // <Typography sx={{ textAlign: "center", margin: "3rem" }}>
            //   No Record Found
            // </Typography>
            <NoRecordFound />
          )}
        </div>
      </Box>
    </>
  );
}
